var _path, _g, _path2, _path3, _g2, _path4, _g3, _path5, _g4, _path6, _g5, _path7, _g6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgBank = function SvgBank(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 284,
    height: 230,
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bank_svg__a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "bank_svg__b",
    width: 230,
    height: 230,
    x: 0,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M229.461 114.871C229.461 51.627 178.295.358 115.18.358S.899 51.628.899 114.871 52.064 229.384 115.18 229.384c63.115 0 114.281-51.269 114.281-114.513"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bank_svg__b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1C22",
    d: "M229.461 114.871C229.461 51.627 178.295.358 115.18.358S.899 51.628.899 114.871 52.064 229.384 115.18 229.384c63.115 0 114.281-51.269 114.281-114.513"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 159.571H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 156.204H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 152.837H121.638v3.515h122.246zM243.884 162.939H121.638v3.516h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 166.307H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 169.674H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 173.041H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 176.409H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 179.776H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 183.143H121.638v3.516h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 186.51H121.638v3.516h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 189.878H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 193.245H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 196.613H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 199.98H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 203.347H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 206.714H121.638v3.516h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 210.082H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 213.45H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 216.817H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    stroke: "#429D54",
    d: "M243.884 220.184H121.638v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#46A459",
    d: "M198.444 152.35h-31.365v71.836h31.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 183.143H24.182v3.516h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 186.51H24.182v3.516h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 189.879H24.182v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 193.246H24.182v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 196.613H24.182v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 199.98H24.182v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 203.347H24.182v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 206.715H24.182v3.516h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 210.083H24.182v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 213.45H24.182v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 216.817H24.182v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    stroke: "#5AC16F",
    d: "M146.428 220.184H24.182v3.515h122.246z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5AC16F",
    d: "M100.988 182.656H69.623v41.531h31.365z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#276433",
    fillOpacity: 0.5,
    d: "m146.915 181.534 18.479 21.57 18.479 20.337h-36.958z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M-.795 119.653C-.795 55.471 51.129 3.442 115.18 3.442s115.975 52.03 115.976 116.211c0 0-14.229-70.78-115.976-70.78-101.748 0-115.975 70.78-115.975 70.78"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#2C45BB",
    strokeWidth: 6,
    d: "M226.543 114.871c0-61.629-49.859-111.589-111.363-111.589S3.817 53.242 3.817 114.871 53.676 226.46 115.18 226.46s111.363-49.96 111.363-111.589Z"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "bank_svg__c",
    width: 40,
    height: 230,
    x: 205,
    y: 0,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M205.293 12.54c0-6.458 5.225-11.694 11.671-11.694h21.398c3.222 0 5.835 2.618 5.835 5.847v217.331c0 3.229-2.613 5.847-5.835 5.847h-21.398c-6.446 0-11.671-5.236-11.671-11.695z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bank_svg__c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#3B58E3",
    d: "M205.293 12.54c0-6.458 5.225-11.694 11.671-11.694h21.398c3.222 0 5.835 2.618 5.835 5.847v217.331c0 3.229-2.613 5.847-5.835 5.847h-21.398c-6.446 0-11.671-5.236-11.671-11.695z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2C45BB",
    d: "M244.197.846h-38.904V23.26h38.904z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bank_svg__d",
    width: 20,
    height: 112,
    x: 244,
    y: 59,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M244.197 59.32h15.562a3.894 3.894 0 0 1 3.89 3.898v103.306a3.894 3.894 0 0 1-3.89 3.898h-15.562z"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bank_svg__d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#2C45BB",
    d: "M244.197 59.32h15.562a3.894 3.894 0 0 1 3.89 3.898v103.306a3.894 3.894 0 0 1-3.89 3.898h-15.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#253CAB",
    d: "M283.101 59.32h-38.904v17.543h38.904z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bank_svg__e",
    width: 21,
    height: 71,
    x: 263,
    y: 79,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M263.649 79.786h15.562a3.894 3.894 0 0 1 3.89 3.899v62.373a3.894 3.894 0 0 1-3.89 3.898h-15.562z"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bank_svg__e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1C22",
    d: "M263.649 79.786h15.562a3.894 3.894 0 0 1 3.89 3.899v62.373a3.894 3.894 0 0 1-3.89 3.898h-15.562z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M302.553 79.786h-38.904V97.33h38.904z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bank_svg__f",
    width: 12,
    height: 32,
    x: 244,
    y: 28,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M244.197 33.981a5.84 5.84 0 0 1 5.836-5.847c3.222 0 5.835 2.618 5.835 5.847v25.34h-11.671z"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bank_svg__f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1C22",
    d: "M244.197 33.981a5.84 5.84 0 0 1 5.836-5.847c3.222 0 5.835 2.618 5.835 5.847v25.34h-11.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M255.868 28.134h-11.671v11.695h11.671z"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "bank_svg__g",
    width: 12,
    height: 32,
    x: 244,
    y: 170,
    maskUnits: "userSpaceOnUse",
    style: {
      maskType: "luminance"
    }
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M255.868 195.761c0 3.229-2.613 5.848-5.835 5.848s-5.836-2.619-5.836-5.848v-25.339h11.671z"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#bank_svg__g)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1F1C22",
    d: "M255.868 195.761c0 3.229-2.613 5.848-5.835 5.848s-5.836-2.619-5.836-5.848v-25.339h11.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M244.197 201.609h11.672v-11.695h-11.672z"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bank_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h284v230H0z"
  })))));
};
export default SvgBank;